import { EditViewDigitalSignatureRequestDTO } from "../../components/request-digital-signature/ViewDigitalSignatureModal.types";
import { CreateDigitalSignatureRequestDTO } from "../../entities/IDigitalSignatureRequest";
import BaseInstance from "../BaseInstance";
import { AxiosResponse } from "axios";
import environment from "../../config/environment";
import axios from "axios";
import { translation } from "../../components/translations";

const DigitalSignatureGateway = {
  getWebSigningDocument: async (
    id: string,
    data: { email: string; token: string }
  ): Promise<AxiosResponse<Blob>> => {
    const url = `${environment.api.protocol}://${environment.api.host}${
      environment.api.port ? ":" + environment.api.port : ""
    }/${
      environment.api.version ? environment.api.version + "/" : ""
    }digital-sign-requests/${id}/get-websigning-document`;

    return axios.post<Blob>(url, data, {
      responseType: "blob",
      headers: {
        "accept-language": translation.language,
      },
    });
  },

  submitWebSignedDocument: async (formData: FormData) => {
    return BaseInstance.patch("/digital-sign-requests/websign", formData);
  },
  confirmEmailBeforeSigningPdf: async ({ token, email }: { token: string; email: string }) => {
    return BaseInstance.get(`/digital-sign-requests/confirm`, {
      headers: {
        Accept: "application/json",
      },
      params: {
        token,
        email,
      },
    });
  },
  createDigitalSignatureRequest: async (payload: CreateDigitalSignatureRequestDTO) => {
    const payloadToSend: CreateDigitalSignatureRequestDTO = {
      ...payload,
      authorizedSignatory: Number(payload.authorizedSignatory) || 0,
    };

    return BaseInstance.post("/digital-sign-requests", payloadToSend);
  },
  deleteDigitalSignatureRequest: async (id: number) => {
    return BaseInstance.delete(`/digital-sign-requests/${id}`);
  },
  editDigitalSignatureRequest: async (id: string, payload: EditViewDigitalSignatureRequestDTO) => {
    return BaseInstance.put(`/digital-sign-requests/${id}`, payload);
  },

  resendDocumentForDigitalSignature: async (
    documentId: string,
    payload: EditViewDigitalSignatureRequestDTO
  ) => {
    return BaseInstance.post(`/digital-sign-requests/resend-request/${documentId}`, payload);
  },
};

export default DigitalSignatureGateway;
